import {Button} from 'shells/button/button';
import {Illustration} from 'shells/illustrations/illustration';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

export type OnboardingInfoContent = {
    illustrationSource: string;
    title: string;
    text: string;
};

interface OnboardingInfoProps extends OnboardingInfoContent {
    onClose?: () => void;
}

export function OnboardingInfo(props: OnboardingInfoProps) {
    return (
        <div>
            <Illustration src={props.illustrationSource} />
            <div className='pad-16'>
                <Stack spacing={8}>
                    <Body isBold={true}>{props.title}</Body>
                    <Body size='small' maintainLineBreaks={true}>
                        {props.text}
                    </Body>
                    {props.onClose && (
                        <div className='flex justify-end'>
                            <Button variant='primary' size='small' onClick={props.onClose}>
                                Close
                            </Button>
                        </div>
                    )}
                </Stack>
            </div>
        </div>
    );
}
